import React from 'react';
import PropTypes from 'prop-types';
import { getRelValueOutboundLink } from '../../utils';

const OutboundLink = ({
  href,
  className,
  rel = null,
  children = null,
  onClick = () => {},
  dataLinkType = 'text-link',
  target = '_blank',
  sponsoredRel,
}) => {

  let ariaLabel = className;
  if (
    (ariaLabel.includes('icon') && ariaLabel.includes('instagram')) ||
    (ariaLabel.includes('icon') && ariaLabel.includes('twitter')) ||
    (ariaLabel.includes('icon') && ariaLabel.includes('tiktok')) ||
    (ariaLabel.includes('icon') && ariaLabel.includes('youtube')) ||
    (ariaLabel.includes('icon') && ariaLabel.includes('pinterest')) ||
    (ariaLabel.includes('icon') && ariaLabel.includes('facebook'))
  ) {
    const socialName = ariaLabel.replace('social icon-', '');
    ariaLabel = `Visit us on ${socialName}`;
  } else if (ariaLabel.includes('icon') && ariaLabel.includes('podcast')) {
    ariaLabel = 'Visit our Podcasts page';
  } else ariaLabel = className;

  let linkRel = (rel) ? rel : `noopener ${sponsoredRel ? 'sponsored noskim' : 'nofollow'}`;
  linkRel = getRelValueOutboundLink(href, linkRel);

  return (
    <a
      className={className}
      href={href}
      target={target}
      rel={linkRel}
      aria-label={ariaLabel}
      data-link-type={dataLinkType}
      onClick={onClick}>
      {children}
    </a>
  );
};

OutboundLink.propTypes = {
  href: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  onClick: PropTypes.func,
  dataLinkType: PropTypes.string,
};

export default OutboundLink;
